<template>
  <div class="cd-section" id="features">
    <!--     *********     FEATURES 3      *********      -->
    <div class="features-3">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <h2 class="title">{{titulo}}</h2>
            <h4 class="description">{{descripcionGeneral}}</h4>
          </div>
        </div>
        <div class="row">
          <formulario-detalle v-for="item in formularios" :key="item.id" :item="item"></formulario-detalle>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES 3      *********      -->
  </div>
</template>
<script>
import { Card } from "@/components";
import FormularioDetalle from "./cmsComponents/FormularioDetalle";

export default {
  components: {
    Card,
    FormularioDetalle
  },
  data() {
    return {
      formularios: []
    };
  },
  async created() {
    await this.$store.dispatch("resource/getAll");
  },
  computed: {
    titulo() {
      return this.$store.getters["resource/getByName"](
        "Formulario_Prestador_Titulo"
      ).valueNoHtml;
    },
    descripcionGeneral() {
      return this.$store.getters["resource/getByName"](
        "Formulario_Prestador_Descripcion"
      ).valueNoHtml;
    }
  },
  mounted() {
    this.$zaiq()
      .get("Formulario/AdvancedGetAll?tipo=prestador")
      .then(response => {
        console.log(response.data.result.items);
        this.formularios = response.data.result.items;
      });
  }
};
</script>
<style>
</style>
